// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.domino-content {
  width: 1320px;
  margin: auto;
}
.domino-app.main-panel {
  align-items: top;
}`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Domino/styles/DominoApp.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".domino-content {\n  width: 1320px;\n  margin: auto;\n}\n.domino-app.main-panel {\n  align-items: top;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
